//Core modules
import React, { Fragment, useState} from 'react';

//External modules
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import cx from "classnames";

//Internal modules
import CratioTextInput from "../Common/CratioTextInput";
import requestApi from "../../services/requestApi.service";
import {clearSessionValue, handleErrorResponse, setSessionValue, getLogoutURL} from "../../Common/Appcommon";

const ChangePwd = props => {

    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});

    const isClearable = (props.isClearable !== undefined && props.isClearable);

    const submitForm = async (e) => {
        e.preventDefault();

        if(formData['newpwd'] !== formData['confirmpwd']){
            let err = {...errors};
            err['confirmpwd'] = "Passwords not matching.";
            setErrors(err);
            return;
        }

        const auditInfo = {"displaystring" : ""};
        const formInputFields = {
            'table_changepwd_id' : '',
            'table_11_0_table_11_id' : '',
            'table_11_0_table_11_name' : '',
            'Answer' : '',
            'SUBTABLE_INPUTFIELDS' : '',
            'SUBTABLELINK_INPUTFIELDS' : '',
            'LINEITEM_INPUTFIELDS' : '',
            'BASETABLE_INPUTFIELDS' : '',
            ...formData
        };
        const formFieldDetails = {
            'table_changepwd_id':['Text','',false],
            'currentpassword':['Password','',false],
            'newpwd':['Password','',false],
            'table_11_0_table_11_id':['reference_entityid','',false],
            'table_11_0_table_11_name':['reference','',false,'table_11','Question','0'],
            'Answer':['Password','',false]
        };

        let params = {
            "FORM_INPUTFIELDS" : formInputFields,
            "FORM_FIELDSDETAIL" : formFieldDetails,
            "ENTITY": "FORMPROCESS",
            "OPERATION": "SAVE",
            "MODULENAME" : "Settings",
            "FORMNAME" : "changepwd",
            "concurrent_process_confirmed" : false,
            "FORMTYPE" : "config",
            "auditinfo" : auditInfo
        };

        let response = await requestApi.processServerRequest(params,'WebV2','post');
        if(response.issuccess) {
            clearSessionValue();
            window.location = getLogoutURL();//process.env.REACT_APP_CRATIO_LOGIN_URL;
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const handleChange = (e) => {
        let name = e.target.name;
        formData[name] = e.target.value;
        setFormData(formData);
    }

    const cancelForm = () => {
        setSessionValue('changePwd','false');
        window.location.reload();
    }

    const header = "Change Password";
    const btnText = "Save";
    const cancelText = "Cancel";

    return (
        <Fragment>
            <Modal size={'md'} isOpen={true} >
                <form name={'tag'} onSubmit={(e) =>{return submitForm(e)}}>
                    <ModalHeader >
                        {header}
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            <div className={`mb-3`}>
                                <label className={''} htmlFor="tag_name">{`Current Password`}</label>
                                <CratioTextInput
                                    type={'password'}
                                    inputClass={`form-control`}
                                    value={formData['currentpassword'] !== undefined ? formData['currentpassword'] : ''}
                                    controls={
                                        {
                                            required : true,
                                            name : 'currentpassword',
                                            autoComplete : 'off'
                                        }
                                    }
                                    onChange={handleChange}
                                    skipValidityCheck={true}
                                />
                            </div>
                            <div className={`mb-3`}>
                                <label className={''} htmlFor="tag_name">{`New Password`}</label>
                                <CratioTextInput
                                    type={'password'}
                                    inputClass={`form-control`}
                                    value={formData['newpwd'] !== undefined ? formData['newpwd'] : ''}
                                    controls={
                                        {
                                            required : true,
                                            name : 'newpwd',
                                            autoComplete : 'off'
                                        }
                                    }
                                    onChange={handleChange}
                                    skipValidityCheck={true}
                                />
                            </div>
                            <div className={`mb-3`}>
                                <label className={''} htmlFor="tag_name">{`Confirm Password`}</label>
                                <CratioTextInput
                                    type={'password'}
                                    inputClass={cx(`form-control`,{
                                        'is-invalid' : errors['confirmpwd'] !== undefined && errors['confirmpwd'] !== ""
                                    })}
                                    value={formData['confirmpwd'] !== undefined ? formData['confirmpwd'] : ''}
                                    controls={
                                        {
                                            required : true,
                                            name : 'confirmpwd',
                                            autoComplete : 'off'
                                        }
                                    }
                                    onChange={handleChange}
                                    skipValidityCheck={true}
                                />
                                {
                                    errors.confirmpwd &&
                                    errors.confirmpwd !== "" &&
                                    <em className={`error invalid-feedback`}>{errors.confirmpwd}</em>
                                }
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className={cx('le-button br-4 btn open_chat_btn btn btn-success',{
                            'hide' : !isClearable
                        })} onClick={cancelForm} >
                            {cancelText}
                        </button>
                        <Button className={`le-button lePrimaryBtn br-4`} color="primary" type={'submit'}>
                            {btnText}
                        </Button>
                    </ModalFooter>
                </form>
            </Modal>
        </Fragment>
    );
}

export default ChangePwd;